// extracted by mini-css-extract-plugin
module.exports = {"info":"Table_info__3k3le"};